import type { MenuItem, CardData, FunTool } from "./types";

export const BTN_BG = "#4a4a4c";
export const BTN_BG_HOVER = "#3a3a3c";
export const BTN_TEXT = "#ffffff";

export const menuItems: MenuItem[] = [
  { id: "bazi", label: "八字排盘", icon: "ri-compass-discover-line" },
  { id: "zodiac", label: "星座占卜", icon: "ri-star-smile-line" },
  { id: "tarot", label: "塔罗牌", icon: "ri-magic-line" },
  { id: "ziwei", label: "紫微斗数", icon: "ri-user-star-line" },
  { id: "fun", label: "占卜问事", icon: "ri-apps-line" },
];

export const cardDataMap: Record<string, CardData> = {
  bazi: {
    title: "八字排盘",
    subTitle: "四柱八字，洞察天命",
    button: "开始排盘",
    desc: "输入出生年月日时，自动生成四柱八字命盘，详解五行旺衰、十神格局与人生运势",
    bgImage:
      "/images/experience/exp-bazi-bg.jpg",
  },
  zodiac: {
    title: "星座占卜",
    subTitle: "十二星座，运势指引",
    button: "查看运势",
    desc: "根据你的太阳星座与上升星座，解读每日、每周、每月运势，把握爱情、事业与财富",
    bgImage:
      "/images/experience/exp-zodiac-bg.jpg",
  },
  tarot: {
    title: "塔罗牌",
    subTitle: "78张牌，揭示未来",
    button: "抽取牌阵",
    desc: "经典韦特塔罗牌阵，针对爱情、事业、抉择等问题，获得深层的心灵指引与启示",
    bgImage:
      "/images/experience/exp-tarot-bg.jpg",
  },
  shengxiao: {
    title: "生肖运势",
    subTitle: "十二生肖，流年运势",
    button: "查看运势",
    desc: "以十二生肖地支为本，结合流年太岁与五行生克，解读各生肖整年运势、事业财运与情感健康走向",
    bgImage:
      "/images/experience/exp-zodiac-bg.jpg",
  },
  ziwei: {
    title: "紫微斗数",
    subTitle: "天下第一神数",
    button: "生成命盘",
    desc: "以出生时辰排定十二宫位与百余星曜，详解性格、事业、情感、财富各面向",
    bgImage:
      "/images/experience/exp-ziwei-bg.jpg",
  },
  fun: {
    title: "占卜问事",
    subTitle: "体验多种趣味占卜工具",
    button: "开始体验",
    desc: "探索多种趣味占卜工具，轻松体验命理世界",
    bgImage:
      "/images/experience/exp-fun-bg.jpg",
  },
};

export const funTools: FunTool[] = [
  {
    id: "shengbei",
    name: "聖杯",
    icon: "ri-cup-line",
    desc: "求問神明，擲筊解惑",
    bgImage:
      "/images/fun/fun-shengbei.jpg",
  },
  {
    id: "guaqian",
    name: "卦籤",
    icon: "ri-file-list-line",
    desc: "抽籤問事，吉凶指引",
    bgImage:
      "/images/fun/fun-guaqian.jpg",
  },
  {
    id: "shengxiaopeidui",
    name: "生肖配對",
    icon: "ri-heart-3-line",
    desc: "十二生肖緣分配對",
    bgImage:
      "/images/fun/fun-zodiac-match.jpg",
  },
  {
    id: "liuyaogigua",
    name: "六爻起卦",
    icon: "ri-stack-line",
    desc: "六爻預測，洞察先機",
    bgImage:
      "/images/fun/fun-liuyao.jpg",
  },
  {
    id: "lingbai",
    name: "靈擺",
    icon: "ri-vip-diamond-line",
    desc: "靈擺尋找答案與指引",
    bgImage:
      "/images/fun/fun-lingbai.jpg",
  },
  {
    id: "meihuayishu",
    name: "梅花易數",
    icon: "ri-flower-line",
    desc: "以象數起卦，測事推運",
    bgImage:
      "/images/fun/fun-meihua.jpg",
  },
  {
    id: "zhanxingtouzi",
    name: "占星骰子",
    icon: "ri-dice-line",
    desc: "星座骰子，隨機占卜",
    bgImage:
      "/images/fun/fun-dice.jpg",
  },
  {
    id: "shicaogigua",
    name: "蓍草起卦",
    icon: "ri-seedling-line",
    desc: "古法蓍草，誠心問卦",
    bgImage:
      "/images/fun/fun-shicao.jpg",
  },
];
